import { ApolloError } from "@apollo/client";

/**
 * Thrown GraphQL errors are faults (auth / not-found / validation) — surface
 * them with the support `requestId` when present
 * (docs/server-checkout-migration.md §1.5.12). Result-object outcomes
 * (conflict, PlaceOrderResult.status) are UI states and never go through here.
 */
export function describeGqlError(e: unknown, fallback: string): string {
  if (e instanceof ApolloError) {
    const gqlError = e.graphQLErrors && e.graphQLErrors[0];
    const message = gqlError?.message || e.message || fallback;
    const requestId = gqlError?.extensions?.requestId;
    return typeof requestId === "string" && requestId
      ? `${message} (ref: ${requestId})`
      : message;
  }
  return e instanceof Error ? e.message : fallback;
}
